import apiClient from '../../utils/apiClient';
import { GetAllProductsResponse, GetProductDetailsResponse, GetProductsByModelResponse } from './productModels';

/**
 * Get all products grouped by categories
 * @returns Promise with products grouped by categories
 */
export const fetchAllProducts = async (): Promise<GetAllProductsResponse> => {
  const response = await apiClient.get<GetAllProductsResponse>('/products');
  return response.data;
};

/**
 * Get product details including related products
 * @param productId - Product ID
 * @returns Promise with product details and related products
 */
export const fetchProductDetails = async (productId: string): Promise<GetProductDetailsResponse> => {
  const response = await apiClient.get<GetProductDetailsResponse>(`/products/${productId}`);
  return response.data;
};

/**
 * Get products by model
 * @param model - Model name
 * @returns Promise with products matching the model
 */
export const fetchProductsByModel = async (model: string): Promise<GetProductsByModelResponse> => {
  const response = await apiClient.get<GetProductsByModelResponse>(`/products/model/${model}`);
  return response.data;
};

